/**
 * Author: Guillaume Bois
 * required jQuery 1.7+
 *
 * usage:
 *  $(this).on("clickOutside", function(){ // set custom event clickOutside
			$(this).hide(300, hideCallback).off("clickOutside");
		});
 *
 */
// Monkey patch on and off methods
(function($, window){
	var outsideEvent = "clickOutside";
	window.clickOutside = [];
	var _oldOn = $.fn.on;
	$.fn.on = function(event,handler){
		if(event == outsideEvent){
			//$.fn.off.apply(this, arguments); // make sure the event is never registered twice
			window.clickOutside.push(this[0]);
		}
		return _oldOn.apply(this, arguments);
	};
	var _oldOff = $.fn.off;
	$.fn.off = function(event,handler){
		if(event == outsideEvent){
			$.each(window.clickOutside, function(i, o){
				if(this == o){
					window.clickOutside.splice(i, 1);
				}
			})
		}
		return _oldOff.apply(this, arguments);
	};
	// On page ready listen for clickOutside event
	$(function(){
		$("body").on("click", function(event){
			var $target = $(event.target);
			$.each(window.clickOutside, function(i, o){
				// trigger outside event handler of every container that has one if the clicked element is not the container or a child of it
				if($._data(o, "events") && $._data(o, "events")[outsideEvent] && !$(o).find("*").andSelf().has($target).length){
					$(o).trigger(outsideEvent);
				}
			});
		});
	})
})(jQuery, window);
